import React from "react";
import { Link } from "react-router-dom";
import EmployeePageShell from "./EmployeePageShell";
import JobCard from "../Jobs/JobCard";

const previewJob = {
  id: "preview-frontend-developer",
  logo: "/images/resource/company-logo/1-1.png",
  title: "Frontend Developer",
  company: "BrightTech",
  location: "Remote",
  time: "Preview",
  salary: "$55k - $75k",
  type: "Full Time",
  privacy: "Public",
  required: "Urgent",
};

const previewChecklist = [
  { id: "title", text: "Job title and location are clear." },
  { id: "salary", text: "Salary range is visible to candidates." },
  { id: "description", text: "Responsibilities and requirements are ready." },
  { id: "expiry", text: "Listing will expire 30 days after admin approval." },
];

const EmployeeJobPreview = () => {
  return (
    <EmployeePageShell
      active="post-job"
      title="Job Preview"
      text="Review how the job post will appear before publishing."
    >
      <div className="row">
        <div className="col-lg-8">
          <div className="ls-widget preview-job-card">
            <div className="widget-title">
              <h4>Candidate View</h4>
              <Link to="/employee-post-job" className="theme-btn btn-style-three">Edit Job</Link>
            </div>
            <div className="widget-content">
              <JobCard job={previewJob} />
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="ls-widget">
            <div className="widget-title"><h4>Publish Checklist</h4></div>
            <div className="widget-content">
              <ul className="static-list">
                {previewChecklist.map((item) => <li key={item.id}>{item.text}</li>)}
              </ul>
              <Link to="/employee-manage-jobs" className="theme-btn btn-style-one">Publish Job</Link>
            </div>
          </div>
        </div>
      </div>
    </EmployeePageShell>
  );
};

export default EmployeeJobPreview;
